import GeneralOptionsPanel from "components/optionspanel/GeneralOptionsPanel";
import { ExternalEventDetailSection } from "externalEvent/ExternalEventDetailSection";
import TwoColumnLayout from "layout/TwoColumnLayout";
import React from "react";
import { useLoaderData } from "react-router";

const ExternalEventDetail = () => {
  const viewModel = useLoaderData<server.viewmodel.ExternalEventDetailFrontModel>();

  return <TwoColumnLayout>
    <TwoColumnLayout.LeftColumn>
      <ExternalEventDetailSection
        externalEvent={viewModel.externalEvent}
        externalCalendar={viewModel.externalCalendar}
      />
    </TwoColumnLayout.LeftColumn>
    <TwoColumnLayout.RightColumn>
      <GeneralOptionsPanel
        data={viewModel.optionsPanel}
        links={[{
          href: viewModel.listUrl,
          text: RESX.Buttons.ListView,
          visible: true
        }]}
      />

    </TwoColumnLayout.RightColumn>
  </TwoColumnLayout>
}

export default ExternalEventDetail;